class Player {
    constructor(displayName, avatar, id, publicId, isAdmin) {
        this.displayName = displayName;
        this.avatar = avatar;
        this.id = id;
        this.publicId = publicId;
        this.isAdmin = isAdmin;
    } 
}

export default Player;